import logoBrand from '@/assets/images/logo_basciano.svg'
import { Button } from '@/components/atoms/Button/Button'
import { LanguageSelector } from '@/components/molecules/LanguageSelector/LanguageSelector'
import { Logo } from '@/components/molecules/Logo/Logo'
import { useModal } from '@/hooks/useModal'
import { motion } from 'framer-motion'
import { Menu } from 'lucide-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { MenuMobile } from '../MenuMobile/MenuMobile'
import { Modal } from '../Modal/Modal'

interface HeaderProps {
  isError?: boolean
}

const Header: React.FC<HeaderProps> = ({ isError = false }) => {
  const { t } = useTranslation()
  const [isOpenModal, openModal, closeModal] = useModal(false)
  const navigate = useNavigate()

  // Función para manejar el scroll al hacer clic en los enlaces
  const handleScroll = (sectionId: string): void => {
    if (isError) {
      navigate('/')
    } else {
      // De lo contrario, desplázate a la sección correspondiente
      const section = document.getElementById(sectionId)
      if (section != null) {
        section.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }

  return (
    <>
      <motion.header
        className='p-4 bg-white/90 z-10 fixed w-full shadow-md'
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className='w-full container lg:max-w-[1220px] mx-auto px-0 flex justify-between items-center'>
          <Logo src={logoBrand} alt='Basciano Hong Kong Logo' width={200} height={80} />
          <div className='hidden lg:flex gap-2 items-center'>
            <nav className='flex items-center gap-4'>
              <ul className='flex items-center gap-4'>
                <li>
                  <button onClick={() => handleScroll('home')} className='text-primary hover:text-secondary font-bold'>
                    {t('header.home')}
                  </button>
                </li>
                <li>
                  <button onClick={() => handleScroll('aboutUs')} className='text-primary hover:text-secondary font-bold'>
                    {t('header.about')}
                  </button>
                </li>
                <li>
                  <button onClick={() => handleScroll('services')} className='text-primary hover:text-secondary font-bold'>
                    {t('header.services')}
                  </button>
                </li>
                <li>
                  <button onClick={() => handleScroll('formContactUs')} className='text-primary hover:text-secondary font-bold'>
                    {t('header.contact')}
                  </button>
                </li>
              </ul>
            </nav>
          </div>
          <div className='gap-4 items-center hidden lg:flex'>
            {/* <Languages className='mr-2' size={20} /> */}
            <LanguageSelector className='mr-2' basic />
            <Button className='uppercase'>{t('header.buttonGetStarted')}</Button>
            <Button className='border border-primary text-primary hover:bg-primary font-semibold hover:text-white bg-transparent'>{t('header.login')}</Button>
          </div>
          <div className='flex lg:hidden' onClick={openModal}>
            <Menu size={24} />
          </div>
        </div>
      </motion.header>
      <Modal isOpenModal={isOpenModal} closeModal={closeModal}>
        <MenuMobile closeModal={closeModal} />
      </Modal>
    </>
  )
}

export default Header
